import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazyWatermarkConfigurationPage: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-WatermarkConfigurationContainer" */ '../src/WatermarkConfiguration/WatermarkConfigurationPage.tsx'
			)
		).WatermarkConfigurationPage,
});
